import { createSelector } from 'reselect';

import { IAppState } from '../../reducers';

export const selectCsCustomMessageState = (state: IAppState) => state.createSend.customMessage;

export const selectCsCustomMessageEnabled = createSelector(
  selectCsCustomMessageState,
  (customMessage) => customMessage.enabled,
);

export const selectCsCustomMessageTemplateId = createSelector(
  selectCsCustomMessageState,
  (customMessage) => customMessage.templateId,
);

export const selectCsCustomMessageMessage = createSelector(
  selectCsCustomMessageState,
  (customMessage) => customMessage.message,
);

export const selectCsIsCustomMessageStepValid = createSelector(
  selectCsCustomMessageEnabled,
  selectCsCustomMessageTemplateId,
  selectCsCustomMessageMessage,
  (enabled, templateId, message): boolean => !enabled || (templateId !== null && Boolean(message.trim())),
);
